import axios from 'axios'
import store from '@/store'
import bus from 'vue3-eventbus'

// 接口地址的唯一来源，切环境只改这里；withdrawApi.js 也从这里取
// export const baseUrl = 'https://usapi.agent61.com/awclient' // prod
// export const baseUrl = 'https://h5-api.agent61.com/awclient'
// export const baseUrl = 'http://localhost:18201/awclient'
export const baseUrl = 'https://uscg-api.teamraid.xyz/awclient' // 测试

export const customerUrl = 'https://h5-landscape.agent61.com'

export const reportBuriedPointUrl = 'https://report.taurus.cash'

// const baseH5Url = 'https://h5-usapi.agent61.com' // prod
// const baseH5Url = 'https://uscg.teamraid.xyz'
// const baseH5Url = 'http://localhost:8080'
// 使用当前页面所在域名
const baseH5Url = (typeof window !== 'undefined' && window.location && window.location.origin)
  ? window.location.origin
  : ''

const withdrawUrl = ''
const http = axios.create({
  baseURL: baseUrl,
  timeout: 20_000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
})

let headers = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

// 请求失败时返回统一结构，避免调用方访问 undefined.code 崩溃
function httpError(err) {
  console.error('http error:', err)
  return { code: -1, msg: (err && err.message) || 'network error', data: null }
}

function postHttp(url, data) {
  return http.post(url, data).then((resp) => {
    return resp.data
  }).catch(httpError)
}

function getHttp(url) {
  return http.get(url).then((resp) => {
    return resp.data
  }).catch(httpError)
}

function uuid() {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8,
    1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";

  var uuid = s.join("");
  return uuid;
}

// 安全解析 localStorage 里的 JSON，失败时返回兜底值
function safeParse(str, fallback) {
  try {
    return JSON.parse(str) || fallback
  } catch (e) {
    return fallback
  }
}

export function reportEvent(key, value) {
  let sdkParams = safeParse(window.localStorage.getItem('h5_sdk_params'), {});
  let aid = sdkParams.aid || '';
  let uid = sdkParams.uid || '';
  let pkg = sdkParams.pkg || '';
  let channel = sdkParams.channel || '';
  let pn = sdkParams.pn || '';
  let version = sdkParams.version || '';
  let gaid = sdkParams.gaid || '';
  let now = (new Date().getTime() / 1000).toFixed(0);
  let listJson = [{
    ts: now,
    eventKey: key,
    eventValue: value
  }];
  let taurusStatUuid = uuid();
  let appInfo = safeParse(window.localStorage.getItem('vuex'), {});
  let sendData = JSON.stringify({
    code: appInfo.code,
    cts: now,
    pkg: pkg,
    channel: channel,
    pn: pn,
    aid: aid,
    gaid: gaid,
    taurusStatUuid: taurusStatUuid,
    uid: uid,
    type: "event",
    listJson: listJson,
    version: version
  });
  report('/producerController/send', sendData).then((data) => {
    if (!data || !data.data) {
      console.log(key + ":" + value + " report failed");
    }
  }).catch(err => console.error(err));
}

// event request
function report(url, data) {
  let result = axios({
    method: "post",
    url: url,
    data: JSON.stringify(JSON.parse(data)),
    baseURL: reportBuriedPointUrl,
    headers: headers,
  })
    .then((resp) => {
      return resp.data;
    })
    .catch((error) => {
      return "exception=" + error;
    });
  return result;
}

http.interceptors.request.use(function (config) {
  config.headers.token = store.state.token
  return config
})

// iOS 壳把登录态存在原生侧，清 token 时必须一并通知，否则下次冷启动
// store/index.js 的 appConfig() 会把 ios_token 又顶回来，等于没退成
function savedataToNative (key, value) {
  if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.savedata) {
    window.webkit.messageHandlers.savedata.postMessage({ key, value })
  }
}

// token 过期（服务端 401）后的统一退登，行为和 MyCashView 里手动退出保持一致。
// token 存在 vuex 里，vuex-persistedstate 会同步清掉 localStorage 的那份。
// 一批并发请求会一起 401，靠「token 已为空就直接返回」做幂等，只处理第一个。
export function handleTokenExpired () {
  if (!store.state.token) {
    return
  }
  store.commit('token', '')
  window.localStorage.setItem('login_state', '0')
  savedataToNative('ios_token', '')
  savedataToNative('ios_code', '')
  // 过期是被动退登，不该锁死在强制登录弹窗里（forceLogin 只给余额>20 的场景用）
  store.commit('forceLogin', false)
  store.commit('showLogin', true)
  // 提现页等不挂载 AppMain（登录弹窗宿主）的页面，自己监听这个事件做跳转/关页
  bus.emit('tokenExpired')
}

// token 过期两种返回形态都兜住：HTTP 401，以及 HTTP 200 但业务码 401
http.interceptors.response.use(
  function (response) {
    if (response.data && response.data.code === 401) {
      handleTokenExpired()
    }
    return response
  },
  function (error) {
    if (error && error.response && error.response.status === 401) {
      handleTokenExpired()
    }
    return Promise.reject(error)
  }
)

export default {
  postHttp,
  getHttp,
  baseH5Url,
  customerUrl,
  reportEvent,
  handleTokenExpired
}
